<template>
    <div class="row">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group">
                    <label class="col-form-label" for="bedrijf">Bedrijf&nbsp;&nbsp;&nbsp;</label>
                    <select @change="retrieveDataEnAfdelingen" type="text" class="form-control" name="bedrijf" id="bedrijf" v-model="currentFilter.bedrijf">
                        <template v-for="bedrijf in bedrijven">
                            <option :value="bedrijf.id" :selected="bedrijf.id == currentFilter.bedrijf">{{bedrijf.naam}}</option>
                        </template>
                    </select>
                </div>
                <div class="form-group">
                    <label class="col-form-label" for="afdeling">&nbsp;&nbsp;&nbsp;Afdeling&nbsp;&nbsp;&nbsp;</label>
                    <select @change="retrieveData" type="text" class="form-control" name="afdeling" id="afdeling" v-model="currentFilter.afdeling">
                        <template v-for="afdeling in afdelingen">
                            <option :value="afdeling.id" :selected="afdeling.id == currentFilter.afdeling">{{afdeling.naam}} - {{afdeling.bedrijf.naam}}</option>
                        </template>
                    </select>
                </div>
                &nbsp;&nbsp;&nbsp;
                <label class="control control--checkbox">Historiek
                    <input @change="retrieveCheckbox" type="checkbox" v-model="currentFilter.historiek" />
                    <div class="control__indicator"></div>
                </label>
            </form>
        </div><!--/.col-->
    </div><!--/.row-->
</template>

<script>
    export default {
        name: 'FilterForm',
        props: ['bedrijven', 'afdelingen', 'currentFilter', 'get-items'],
        methods: {
            retrieveDataEnAfdelingen () {
                this.currentFilter.afdeling = 0;
                this.$emit('get-items', true);
            },
            retrieveData () {
                this.$emit('get-items', false);
            },
            retrieveCheckbox () {
                // e.preventDefault();
                this.$emit('get-items', false);
            },
        },
    };
</script>

<style>
    .control-group {
        display: inline-block;
        vertical-align: top;
        background: #fff;
        text-align: left;
        box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        padding: 30px;
        width: 200px;
        height: 210px;
        margin: 10px;
    }
    .control {
        display: block;
        position: relative;
        padding-left: 25px;
        margin-bottom: 15px;
        cursor: pointer;
    }
    .control input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }
    .control__indicator {
        position: absolute;
        top: 2px;
        left: 0;
        height: 17px;
        width: 17px;
        background: #e6e6e6;
    }
    .control--radio .control__indicator {
        border-radius: 50%;
    }
    .control:hover input ~ .control__indicator,
    .control input:focus ~ .control__indicator {
        background: #ccc;
    }
    .control input:checked ~ .control__indicator {
        background: #20A8D8;
    }
    .control:hover input:not([disabled]):checked ~ .control__indicator,
    .control input:checked:focus ~ .control__indicator {
        background: #20A8D8;
    }
    .control input:disabled ~ .control__indicator {
        background: #e6e6e6;
        opacity: 0.6;
        pointer-events: none;
    }
    .control__indicator:after {
        content: '';
        position: absolute;
        display: none;
    }
    .control input:checked ~ .control__indicator:after {
        display: block;
    }
    .control--checkbox .control__indicator:after {
        left: 8px;
        top: 3px;
        width: 3px;
        height: 10px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
    .control--checkbox input:disabled ~ .control__indicator:after {
        border-color: #e6e6e6;
    }

</style>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/FilterForm.vue